import React, {Component} from "react";
import Table from "../../components/Table";
import MessageBus from "../../lib/MessageBus";
import CustomerAccessItem from "./CustomerAccessItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {Query} from "react-apollo";
import {ACCOUNT_ACCESS} from "../../queries/customers";

class AccessList extends Component {

  render() {
    let tableHeader = List([
      "Name",
      "Email",
      "Permissions",
    ])              

    let params = {accountId: this.props.accountId}
    return (
      <Query query={ACCOUNT_ACCESS} variables={params}>
        {({ loading, error, data }) => {
          if (loading) return <Loading />
          if (error) return <GraphQLErrors error={error} />
          return (
            <Table 
              extraClassName="AccessList"
              mode="table"
              data={fromJS(data.accountAccess.customers)} 
              renderer={CustomerAccessItem} 
              tableHeader={tableHeader}
              onItemClick={this.handleItemClick.bind(this)}
              itemKey="customerId"
              />
          )
        }}
      </Query>
    )
  }

  handleItemClick(itemData, e, id = "") {
    if (id === "name") {
      MessageBus.publish("navigation", "goto", {
        url: `/customers/${itemData.get("customerId")}`
      })
    }
  }  

}

AccessList.defaultProps = {
  accountId: ""
}

export default AccessList;